<script setup lang="ts">
import { computed, inject, ref, watch } from 'vue'
import { vOnClickOutside } from '@vueuse/components'
import { useTimeoutFn } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

import ProtectionOnIcon from '@kidzonet/dashboard-policy-icons/src/ProtectionOn.vue'
import { useDasboardPolicyStore } from '@kidzonet/dashboard-policy-store'
import Switcher from '@kidzonet/dashboard-policy-swithcer'
import PolicyItem from '@kidzonet/dashboard-policy-widget'
import { $busEmit } from '@kidzonet/inject-bus-emit'
import { getPolicyName } from '@kidzonet/use-policy'

const emit = defineEmits(['changePolicy'])

const { t } = useI18n()

const store = useDasboardPolicyStore()

const tooltip = ref('')
const showTooltip = ref(false)

const isPoliciesLoaded = computed(() => {
    return store.singlePolicies && store.singlePolicies.length > 0
})

watch(isPoliciesLoaded, () => {
    tooltip.value = t(`policy.${store.activeSinglePolicy.name}.long_description`)
})

const { start, stop } = useTimeoutFn(() => {
    showTooltip.value = false
}, 3000)

const busEmit = inject($busEmit)

const showAriaTooltip = () => {
    if (!busEmit) {
        return
    }
    // eslint-disable-next-line ts/ban-ts-comment
    // @ts-ignore
    busEmit('pronounce', {
        message: `protection ${store.onPolicy.isActive ? 'deactivated' : 'activated'}`,
        timeout: 500,
    })
}

const switchPolicy = async () => {
    stop()
    tooltip.value = t(`policy.${store.inactiveSinglePolicy.name}.long_description`)
    showTooltip.value = true
    showAriaTooltip()
    await emit('changePolicy')
    start()
}

const clickOutside = () => {
    showTooltip.value = false
    stop()
}

const tooltipConfig = computed(() => ({
    text: tooltip.value,
    location: 'bottom',
    maxWidth: '400',
    openOnHover: false,
    persistent: showTooltip.value,
    closeDelay: 300,
    modelValue: showTooltip.value,
    id: `id-main-policy-tooltip`,
    ariaLabel: tooltip.value || 'main policy switcher',
}))
</script>

<template>
    <PolicyItem
        v-on-click-outside="clickOutside"
        name="holiday_time"
        :id="store.activeSinglePolicy.id"
        :header="getPolicyName('holiday_time')"
        subheader=""
        :is-active="store.onPolicy.isActive"
        @click="switchPolicy"
        @keyup.enter="switchPolicy"
        v-tooltip="tooltipConfig"
    >
        <template #icon>
            <ProtectionOnIcon />
        </template>
        <Switcher
            :model-value="store.onPolicy.isActive"
        />
        <template #bottom>
            <slot name="bottom" />
        </template>
    </PolicyItem>
</template>
